// import React, { useEffect, useState } from "react";
// import "./Users.css"

// const Users = () => {
//   const [users, setUsers] = useState([]);
//   const [editingUserId, setEditingUserId] = useState(null);
//   const [formData, setFormData] = useState({ username: "", email: "" });
//   const [showModal, setShowModal] = useState(false);
//   const [loading, setLoading] = useState(false);

//   // Fetch all users
//   useEffect(() => {
//     fetchUsers();
//   }, []);

//   const fetchUsers = async () => {
//     try {
//       const res = await fetch("http://localhost:3050/api/users/getallusers");
//       const data = await res.json();
//       setUsers(data.users);
//     } catch (error) {
//       console.error("Error fetching users:", error);
//     }
//   };

//   // Handle edit button click
//   const handleEditClick = async (userId) => {
//     setEditingUserId(userId);
//     setShowModal(true);
//     setLoading(true);
//     try {
//       const res = await fetch(`http://localhost:3050/api/users/user/${userId}`);
//       const data = await res.json();
//       setFormData({ username: data.username, email: data.email });
//     } catch (error) {
//       console.error("Error fetching user:", error);
//     }
//     setLoading(false);
//   };

//   // Update form data
//   const handleChange = (e) => {
//     setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
//   };

//   // Submit updated user
//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     try {
//       await fetch(`/api/users/${editingUserId}`, {
//         method: "PUT",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify(formData),
//       });
//       fetchUsers();
//       setShowModal(false);
//       setFormData({ username: "", email: "" });
//       setEditingUserId(null);
//     } catch (error) {
//       console.error("Error updating user:", error);
//     }
//   };

//   return (
//     <div>
//       <h2>User List</h2>
//       <ul>
//         {users.map((user) => (
//           <li key={user.user_id}>
//             {user.username} - {user.email}
//             <button onClick={() => handleEditClick(user.user_id)}>Edit</button>
//           </li>
//         ))}
//       </ul>

//       {showModal && (
//         <div className="modal">
//           <h3>Edit User</h3>
//           {loading ? (
//             <p>Loading user data...</p>
//           ) : (
//             <form onSubmit={handleSubmit}>
//               <label>Username:</label>
//               <input
//                 name="username"
//                 value={formData.username}
//                 onChange={handleChange}
//                 required
//               />
//               <label>Email:</label>
//               <input
//                 name="email"
//                 value={formData.email}
//                 onChange={handleChange}
//                 required
//               />
//               <button type="submit">Update</button>
//               <button type="button" onClick={() => setShowModal(false)}>
//                 Cancel
//               </button>
//             </form>
//           )}
//         </div>
//       )}
//     </div>
//   );
// };

// export default Users;

import React, { useEffect, useState } from "react";
import "./Users.css";
// import API_URL from '../../config';

const Customers = () => {
  const API_URL = process.env.REACT_APP_API_URL;
  // console.log("API URL:", process.env.REACT_APP_API_URL);
  const [users, setUsers] = useState([]);
  const [email, setEmail] = useState([]);
  const [editingUserId, setEditingUserId] = useState(null);
  const [viewingUser, setViewingUser] = useState(null);
  const [formData, setFormData] = useState({ username: "", email: "" });
  const [showEditModal, setShowEditModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);
  const [loading, setLoading] = useState(false);

  // FOR GOOGLE USERS
  const [googleUsers, setGoogleUsers] = useState([]);
  const [editingGoogleUserId, setEditingGoogleUserId] = useState(null);
  const [viewingGoogleUser, setViewingGoogleUser] = useState(null);
  const [formDataGoogle, setFormDataGoogle] = useState({ name: "", email: "" });
  const [showEditGoogleModal, setShowEditGoogleModal] = useState(false);
  const [showViewGoogleModal, setShowViewGoogleModal] = useState(false);
  const [loadingGoogle, setLoadingGoogle] = useState(false);

  useEffect(() => {
    fetchUsers();
    fetchgoogleUsers();
  }, []);

  const fetchgoogleUsers = async () => {
    try {
      const res = await fetch(`${API_URL}/google/getallusers`);
      const data = await res.json();
      setGoogleUsers(data.users);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };
  const handlegoogleEditClick = async (userId) => {
    setEditingGoogleUserId(userId);
    setShowEditGoogleModal(true);
    setLoadingGoogle(true);
    try {
      const res = await fetch(`${API_URL}/google/getbyid/${userId}`);
      const data = await res.json();
      console.log(data);
      setFormDataGoogle({ name: data?.name, email: data?.email });
    } catch (error) {
      console.error("Error fetching user:", error);
    }
    setLoading(false);
  };
  const handlegoogleViewClick = async (userId) => {
    try {
      const res = await fetch(`${API_URL}/google/getbyid/${userId}`);
      const data = await res.json();
      setViewingGoogleUser(data);
      setShowViewGoogleModal(true);
    } catch (error) {
      console.error("Error viewing user:", error);
    }
  };
  const handlegoogleDeleteClick = async (userId) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this user?"
    );
    if (!confirmDelete) return;

    try {
      await fetch(`${API_URL}/google/deleteuser/${userId}`, {
        method: "DELETE",
      });
      fetchgoogleUsers();
    } catch (error) {
      console.error("Error deleting user:", error);
    }
  };

  const handlegoogleChange = (e) => {
    setFormDataGoogle((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handlegoogleSubmit = async (e) => {
    e.preventDefault();
    try {
      await fetch(`${API_URL}/google/updateuser/${editingGoogleUserId}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formDataGoogle),
      });
      fetchgoogleUsers();
      setShowEditGoogleModal(false);
      setFormDataGoogle({ name: "", email: "" });
      setEditingGoogleUserId(null);
    } catch (error) {
      console.error("Error updating user:", error);
    }
  };

  const handleDeactivateUser = async (userId) => {
    const confirmDeactivate = window.confirm(
      "Are you sure you want to deactivate this user?"
    );
    if (!confirmDeactivate) return;

    try {
      const response = await fetch(
        `${API_URL}/google/deactivateuser/${userId}`,
        {
          method: "PUT",
        }
      );

      if (response.ok) {
        alert("User deactivated successfully!");
        fetchgoogleUsers(); // refresh list
      } else {
        alert("Failed to deactivate user.");
      }
    } catch (error) {
      console.error("Error deactivating user:", error);
      alert("Error deactivating user!");
    }
  };

  const handleActivateUser = async (userId) => {
    const confirmActivate = window.confirm(
      "Are you sure you want to activate this user?"
    );
    if (!confirmActivate) return;

    try {
      const response = await fetch(`${API_URL}/google/activateuser/${userId}`, {
        method: "PUT",
      });

      if (response.ok) {
        alert("User activated successfully!");
        fetchgoogleUsers(); // refresh list
      } else {
        alert("Failed to activate user.");
      }
    } catch (error) {
      console.error("Error activating user:", error);
      alert("Error activating user!");
    }
  };

  // FOR NORMAL USERS

  const fetchUsers = async () => {
    try {
      const res = await fetch(`${API_URL}/users/getallusers`);
      const data = await res.json();
      setUsers(data.users);
      setEmail(data.users[0].email);
      console.log(data.users[0].email);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  const handleEditClick = async (userId) => {
    setEditingUserId(userId);
    setShowEditModal(true);
    setLoading(true);
    try {
      const res = await fetch(`${API_URL}/users/user/${userId}`);
      const data = await res.json();
      setFormData({ username: data.username, email: data.email });
    } catch (error) {
      console.error("Error fetching user:", error);
    }
    setLoading(false);
  };

  const handleViewClick = async (userId) => {
    try {
      const res = await fetch(`${API_URL}/users/user/${userId}`);
      const data = await res.json();
      setViewingUser(data);
      setShowViewModal(true);
    } catch (error) {
      console.error("Error viewing user:", error);
    }
  };

  const handleDeleteClick = async (userId) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this user?"
    );
    if (!confirmDelete) return;

    try {
      await fetch(`${API_URL}/users/delete-user/${userId}`, {
        method: "DELETE",
      });
      fetchUsers();
    } catch (error) {
      console.error("Error deleting user:", error);
    }
  };

  const adminemail = `${email}`;

  const handleDeleteClickhard = async () => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this user?"
    );
    if (!confirmDelete) return;

    try {
      await fetch(`${API_URL}/users/delete-user-hard/${adminemail}`, {
        method: "DELETE",
      });
      fetchUsers();
    } catch (error) {
      console.error("Error deleting user:", error);
    }
  };

  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await fetch(`${API_URL}/users/update-user/${editingUserId}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });
      fetchUsers();
      setShowEditModal(false);
      setFormData({ username: "", email: "" });
      setEditingUserId(null);
    } catch (error) {
      console.error("Error updating user:", error);
    }
  };

  return (
    <div>
      <div className="user-container">
        <h2 style={{ color: "green" }}> Regular user List</h2>
        <table border="1" cellPadding="10">
          <thead>
            <tr>
              <th>User ID</th>
              <th>Username</th>
              <th>Email</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {users.map((user) => (
              <tr key={user.user_id}>
                <td>{user.user_id}</td>
                <td>{user.username}</td>
                <td>{user.email}</td>
                <td>
                  <button onClick={() => handleViewClick(user.user_id)}>
                    View
                  </button>{" "}
                  <button onClick={() => handleEditClick(user.user_id)}>
                    Edit
                  </button>{" "}
                  <button onClick={() => handleDeleteClick(user.user_id)}>
                    Delete
                  </button>
                  <button onClick={() => handleDeleteClickhard(user.user_id)}>
                    Delete hard
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {/* Edit Modal */}
        {showEditModal && (
          <div className="modal">
            <div className="modal-content">
              <h3>Edit User</h3>
              {loading ? (
                <p>Loading user data...</p>
              ) : (
                <form onSubmit={handleSubmit}>
                  <label>Username:</label>
                  <input
                    name="username"
                    value={formData.username}
                    onChange={handleChange}
                    required
                  />
                  <label>Email:</label>
                  <input
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                  <button type="submit">Update</button>
                  <button type="button" onClick={() => setShowEditModal(false)}>
                    Cancel
                  </button>
                </form>
              )}
            </div>
          </div>
        )}

        {/* View Modal */}
        {showViewModal && viewingUser && (
          <div className="modal">
            <div className="modal-content">
              <h3>User Details</h3>
              <p>
                <strong>ID:</strong> {viewingUser.user_id}
              </p>
              <p>
                <strong>Username:</strong> {viewingUser.username}
              </p>
              <p>
                <strong>Email:</strong> {viewingUser.email}
              </p>
              <button onClick={() => setShowViewModal(false)}>Close</button>
            </div>
          </div>
        )}
      </div>

      {/*  google users*/}
      <div className="user-container">
        <h2 style={{ color: "red", marginBottom: "10px" }}>
          {" "}
          Google registered Users
        </h2>
        <table border="1" cellPadding="10">
          <thead>
            <tr>
              <th>User ID</th>
              <th>Name</th>
              <th>Email</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {googleUsers.map((user) => (
              <tr key={user.id}>
                <td>{user.id}</td>
                <td>{user.name}</td>
                <td>{user.email}</td>
                <td>
                  <button onClick={() => handlegoogleViewClick(user.id)}>
                    View
                  </button>
                  <button
                    onClick={() => handlegoogleEditClick(user.id)}
                    disabled
                  >
                    Edit
                  </button>
                  <button
                    onClick={() => handlegoogleDeleteClick(user.id)}
                    disabled
                  >
                    Delete
                  </button>
                  <button
                    onClick={() => handleActivateUser(user.id)}
                    disabled={user.is_active}
                  >
                    Activate
                  </button>
                  <button
                    onClick={() => handleDeactivateUser(user.id)}
                    disabled={!user.is_active}
                  >
                    Deactivate
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {/* Edit Modal */}
        {showEditGoogleModal && (
          <div className="modal">
            <div className="modal-content">
              <h3>Edit User</h3>
              {loadingGoogle ? (
                <p>Loading user data...</p>
              ) : (
                <form onSubmit={handlegoogleSubmit}>
                  <label>Name:</label>
                  <input
                    name="name"
                    value={formDataGoogle?.name}
                    onChange={handlegoogleChange}
                    required
                  />
                  <label>Email:</label>
                  <input
                    name="email"
                    value={formDataGoogle?.email}
                    onChange={handlegoogleChange}
                    required
                  />
                  <button type="submit">Update</button>
                  <button
                    type="button"
                    onClick={() => setShowEditGoogleModal(false)}
                  >
                    Cancel
                  </button>
                </form>
              )}
            </div>
          </div>
        )}

        {/* View Modal */}
        {showViewGoogleModal && viewingGoogleUser && (
          <div className="modal">
            <div className="modal-content">
              <h3>User Details</h3>
              <p>
                <strong>ID:</strong> {viewingGoogleUser.id}
              </p>
              <p>
                <strong>Name:</strong> {viewingGoogleUser.name}
              </p>
              <p>
                <strong>Email:</strong> {viewingGoogleUser.email}
              </p>
              <button onClick={() => setShowViewGoogleModal(false)}>
                Close
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Customers;
